import React from 'react'

import TestProcess from '../../../../../components/pages/Register/PassTheTest/TestProcess'
import TestProcessWrapper from '../../../../../components/pages/Register/PassTheTest/TestProcess/TestProcessWrapper'

const MyClassCategoriesTestProcess = ({ onSubmit, onCancel }) => {
  return (
    <div className="max-w-[820px] mx-auto">
      <TestProcessWrapper>
        <TestProcess onTestSubmit={onSubmit} onCancelTest={onCancel} />
      </TestProcessWrapper>
    </div>
  )
}

export default MyClassCategoriesTestProcess
